import React from "react";
import { default as MatErrorIcon } from "@material-ui/icons/Error";

export const ErrorIcon = () => <MatErrorIcon />;
